<template>
    <div class="toastMessage">
        <p class="txt">{{_modal.toastMsg}}</p>
        <!-- 일단 기능 빼고 추후 예정 -->
        <!-- <p class="btnBox"><button type="button" class="retry">재시도</button></p> -->
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: 'ToastMessage',
        computed: {
            ...mapState(['_modal'])
        }
    }
</script>

<style scoped>
.toastMessage {
    margin: 16px;
    padding: 23px 16px;
    position: fixed;
    display: table;
    vertical-align: middle;
    top: 0;
    right: 0;
    z-index: 100000;
    width: 30%;
    height: 70px;
    font-size: 20px;
    font-weight: bold;
    border-radius: 5px;
    background-color: #4c5857;
}

.toastMessage .txt {
    display: table-cell;
    width: calc(100% - 70px);
    color: #fff;
}

.toastMessage .btnBox {
    display: table-cell;
    vertical-align: middle;
    width: 70px;
}

.toastMessage .retry {
    text-align: right;
    color: #FF1759;
}
</style>